
<template>
  <v-row justify="center">
    <v-dialog v-model="show" persistent max-width="350px">
      <v-card>
        <v-card-title>
          <span class="headline">Change Password</span>
        </v-card-title>
        <v-card-text>
            <ValidationObserver ref="passobserver">
                <v-form ref="passwordform">
                    <v-container>
                        <v-row>
                            <v-col cols="12">
                                <ValidationProvider v-slot="{ errors }" name="Password" rules="required" vid="password">
                                    <v-text-field
                                        ref="password"
                                        type="password"
                                        v-model="form.password"
                                        :error-messages="errors"
                                        label="Password"
                                        required
                                    ></v-text-field>
                                </ValidationProvider>
                            </v-col>
                            <v-col cols="12">
                                <ValidationProvider v-slot="{ errors }" name="Confirm Password" rules="required|confirmed:password">
                                    <v-text-field
                                        ref="confirmPassword"
                                        type="password"
                                        v-model="form.confirmPassword"
                                        :error-messages="errors"
                                        label="Confirm Password"
                                        required
                                    ></v-text-field>
                                </ValidationProvider>
                            </v-col>
                        </v-row>
                    </v-container>
                <v-form>
            </ValidationObserver>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="blue darken-1" text @click="show = false">Close</v-btn>
          <v-btn color="blue darken-1" text @click="submit">Save</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-row>
</template>


<script>
import { mapGetters } from 'vuex'
import { required, confirmed } from 'vee-validate/dist/rules'
import { extend, ValidationObserver, ValidationProvider, setInteractionMode } from 'vee-validate'

setInteractionMode('eager')

extend('required', {
    ...required,
    message: '{_field_} can not be empty',
})

extend('confirmed', confirmed)

export default {
    props: ['show'],
    data () {
        return {
            form: {
                password: '',
                confirmPassword: ''
            },
        }
    },
    computed: {
        ...mapGetters({
            user: 'auth/user'
        }),
    },
    components: {
        ValidationProvider,
        ValidationObserver,
    },
    watch: {
        show(newVal) { // watch it
            this.$emit('update-password', newVal)
        },
    },
    methods: {
        async submit() {
            let valid = await this.$refs.passobserver.validate()

            if(!valid) {
                console.log('test')
            }
        }
    }
}
</script>